export default __webpack_public_path__ + "static/media/pink-slash.b49dbdee.svg";